import React, { useEffect, useState } from 'react';
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';

import tabData from "./subtabs/tabDataPedidos.json"
import { lastOrdersListMain , orderConfirm2 , orderRefuse } from '../../services/OrderService'
import { extractDate, extractTime, formatPhoneNumber, formatCNPJ, formatCPF } from '../helpers/helpers';

const statusMap = {
    0: 'Pendente',
    1: 'Confirmado',
    2: 'Enviado',
    3: 'Entregue',
    4: 'Cancelado',
    5: 'Rejeitado' 
};

const FoodOrder = () => {
    const [loading, setLoading] = useState(true);
    const [orders, setOrders] = useState([]);
    const [orderTaken, setOrderTaken] = useState({});
    const [toggle, setToggle] = useState(false);
    const [refuseModal, setRefuseModal] = useState(false);
    const [acceptModal, setAcceptModal] = useState(false);

    const setModal = (modal, type, content) => {
        if (type === 'accept') {
            setAcceptModal(modal)
        } else if (type === 'refuse') {
            setRefuseModal(modal)
        }
        setOrderTaken(content)
        setToggle(false)
    }

    const handlerOrder = (id, type) => {
        const storeId = JSON.parse(localStorage.getItem('userDetails'));
        console.log('storeId')
        console.log(storeId.profileId)
        if (type === 'accept') {
            const confirmOrderFunc = async () => {
                try {
                    const fetchConfirm = async () => {
                        try {
                            const response = await orderConfirm2(id , storeId.profileId);
                            if (response.status === 200) {
                                setToggle(false)
                            } else {
                                console.error('Erro ao obter os produtos:', response.statusText);
                            }
                        } catch (error) {
                            console.error('Erro ao obter os produtos:', error);
                        }
                    };
                    fetchConfirm();

                } catch (error) {
                    console.error('Erro ao obter o valor de "p" da URL:', error);
                }
            };
            confirmOrderFunc()
            setAcceptModal(false)
        } else if (type === 'refuse') {
            const refuseOrderFunc = async () => {
                try {
                    const fetchRefuse = async () => {
                        try {
                            const response = await orderRefuse(id);
                            if (response.status === 200) {
                                setToggle(false)
                            } else {
                                console.error('Erro ao obter os produtos:', response.statusText);
                            }
                        } catch (error) {
                            console.error('Erro ao obter os produtos:', error);
                        }
                    };
                    fetchRefuse();

                } catch (error) {
                    console.error('Erro ao obter o valor de "p" da URL:', error);
                }
            };
            refuseOrderFunc()
            setRefuseModal(false)
        }
    }

    useEffect(() => {
        if (!toggle) {
            const Orders = async () => {
                try {
                    const fetchProducts = async () => {
                        try {
                            const response = await lastOrdersListMain();
                            if (response.status === 200) {
                                setOrders(response.data.result)
                                setLoading(false)
                            } else {
                                console.error('Erro ao obter os produtos:', response.statusText);
                                setLoading(false)
                            }
                        } catch (error) {
                            console.error('Erro ao obter os produtos:', error);
                            setLoading(false)
                        }
                    };
                    fetchProducts();
                    setToggle(true)
                } catch (error) {
                    console.error('Erro ao obter o valor de "p" da URL:', error);
                }
            };
            Orders()
        }
    },[toggle])

    // useEffect(() => {
    //     console.log('orders')
    //     console.log(orders) 
    // },[orders])

    return (
        <>
            <div className="custom-tab-1 pb-3">
                <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                    <Nav as="ul" className="navigatore">
                        {tabData.map((data, i) => (
                            <Nav.Item as="li" key={'tabData' + i}>
                                <Nav.Link eventKey={data.name.toLowerCase()} href={data.link}>
                                    <i className={`${data.icon} me-2`} />
                                    {data.name}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Tab.Container>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        {orders.sort((a, b) => b.number - a.number).map((item, index) => (
                            <div className="col-xl-4 col-sm-6 sp15 mb-4 " key={'order-' + index}>
                                <div className="h-auto b-hover">
                                    <div className="p-3 position-relative overflow-hidden"
                                        style={{
                                            boxShadow: '2px 2px 2px #f1f1f1',
                                        }}>
                                        {index < 2 && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '30px',
                                                right: '-40px',
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                padding: '5px 40px',
                                                transform: 'rotate(45deg)',
                                                zIndex: 3,
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                            }}>
                                                ÚLTIMO PEDIDO
                                            </div>
                                        )}
                                        {index >= 2 && index < 6 && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '30px',
                                                right: '-40px',
                                                backgroundColor: '#ffc107',
                                                color: 'white',
                                                padding: '5px 40px',
                                                transform: 'rotate(45deg)',
                                                zIndex: 1,
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                            }}>
                                                PEDIDO ABERTO
                                            </div>
                                        )}
                                        <h4
                                            style={{
                                                marginBottom: 1,
                                                backgroundColor: '#f54749',
                                                margin: '-1rem -1rem 1rem -1rem',
                                                padding: '1rem',
                                                color: 'white',
                                            }}
                                        >
                                            Pedido Nº {item.number}
                                        </h4>
                                        <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
                                            <div className="text-left">
                                                <p style={{ marginBottom: 1 }}><i className="bi bi-calendar-date text-primary" style={{ marginRight: 4 }}></i> {extractDate(item.orderDate)} | <i className="bi bi-clock  text-primary" style={{ marginRight: 4 }}></i> {extractTime(item.createDate)}</p>
                                                <h5 style={{ marginBottom: 1 }}>{item.customer.name}</h5>
                                                <p style={{ marginBottom: 1 }}> <i className="bi bi-telephone-fill  text-primary"></i> {formatPhoneNumber(item.customer.phone)}</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div><i className="bi bi-cart-check text-primary" style={{ marginRight: 7 }}></i> { item.paymentMethod.name }</div>
                                        <hr />
                                        <i className="fa-solid fa-location-dot text-primary" style={{ marginRight: 7 }}></i>
                                        {
                                            item.address.street +
                                            ' ( ' + item.address.zipCode + ' ) ' +
                                            ', Nº ' +
                                            item.address.number +
                                            '' +
                                            ' , ' +
                                            item.address.city +
                                            ' - ' + item.address.state
                                        }
                                        <div className="d-flex flex-row align-items-left"
                                            style={{
                                                backgroundColor: "rgb(234, 234, 234)",
                                                padding: "6px 10px",
                                                borderRadius: "3px",
                                                maxHeight: "38px",
                                                gap: 5,
                                                margin: '10px 0'
                                            }}>
                                            <label className="mb-0">status</label>
                                            <h4 className="mb-0 text-primary">{statusMap[item.orderStatus]}</h4>
                                        </div>
                                        <div className="order-menu">
                                            <h6>Itens</h6>
                                            {
                                                item.orderItems.map((a, b) => (
                                                    b < 2 ?
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 2 , paddingBottom: 5 , marginBottom: 5, borderBottom: '1px #dedede solid' }} key={'orderItens-' + b}>
                                                            <div style={{ display: 'flex' }}>
                                                                <img src={'https://core.pskeromais.com.br/' + a.product.images[0].url} />
                                                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                                                    <p style={{ fontSize: 13, marginBottom: 0, marginTop: 0, height: 27 }}>{a.product.name}</p>
                                                                    <b className="text-primary">{a.quantity + ' x'}</b>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginTop: 5, gap: 5 }}>
                                                                <span style={{ display: 'flex', flexDirection: 'row' }}>
                                                                    <label style={{ marginRight: 5, fontSize: 9 }}>unit</label>
                                                                    <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', fontSize: 10, borderBottom: '1px dotted rgb(182 182 182', paddingBottom: 4 }}>
                                                                        {
                                                                            a.product.salePrice ?
                                                                                <i style={{ margin: '0 4px', textDecoration: 'line-through', color: '#a0a0a0' }}>
                                                                                    {a.product.salePrice.toFixed(2) + ' R$'}
                                                                                </i> : null
                                                                        }
                                                                        <b className="text-primary" >
                                                                            {' ' + a.unitPrice.toFixed(2) + ' R$'}
                                                                        </b>
                                                                    </span>
                                                                </span>
                                                                <span>
                                                                    <label style={{ marginRight: 5, fontSize: 9 }}>total</label>
                                                                    <b className="text-primary">
                                                                        {' ' + a.total.toFixed(2) + ' R$'}
                                                                    </b>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        : null
                                                )
                                                )
                                            }
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                <h4 className="mb-0">Total do pedido</h4>
                                                <span style={{ display: 'flex', gap: 5, marginBottom: 7, marginTop: 4 }}>
                                                    <span style={{ display: 'flex', flexDirection: 'column', padding: 5, borderRadius: 6, backgroundColor: 'rgb(234 234 234)' }}>
                                                        <label style={{ fontSize: 12, margin: 0 }}>entrega</label>
                                                        <span className="text-primary" style={{ fontSize: 15, margin: 0 }}>R$ {' ' + item.deliveryRate.toFixed(2)}</span>
                                                    </span>
                                                    <span style={{ display: 'flex', flexDirection: 'column', padding: 5, borderRadius: 6, backgroundColor: 'rgb(234 234 234)' }}>
                                                        <label style={{ fontSize: 12, margin: 0 }}>compra total</label>
                                                        <span className="text-primary" style={{ fontSize: 15, margin: 0 }}>R$ {' ' + item.totalItems.toFixed(2)}</span>
                                                    </span>
                                                    <span style={{ display: 'flex', flexDirection: 'column', padding: 5, borderRadius: 6, backgroundColor: 'rgb(234 234 234)' }}>
                                                        <label style={{ fontSize: 12, margin: 0 }}>desconto</label>
                                                        <span className="text-primary" style={{ fontSize: 15, margin: 0 }}>R$ {' ' + item.discount.toFixed(2)}</span>
                                                    </span>
                                                </span>
                                                <label style={{ fontSize: 12, margin: 0 }}><b>TOTAL</b></label>
                                                <h2 className="m-0 text-primary">R$ {' ' + (item.totalAmount + item.deliveryRate).toFixed(2)}</h2>

                                            </div>
                                            <hr />
                                            <div style={{ display: 'flex', gap: 5 }}>
                                                <a href={`/pedido?p=${item.id}`} className='btn btn-primary' style={{ padding: '3px 10px' }}>
                                                    VER PEDIDO
                                                </a>
                                                {item.orderStatus === 0?
                                                <>
                                                    <a className='btn btn-secondary' onClick={() => setModal(true, 'accept', item)} style={{ padding: '3px 10px' }}>
                                                        ACEITAR
                                                    </a>
                                                </>:null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Modal show={acceptModal} onHide={setAcceptModal} centered>
                <button onClick={() => setAcceptModal(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <i className="fa-regular fa-circle-check" style={{ fontSize: 30 }}></i>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1' }}>Aceitar Pedido?</h4>
                    <br />
                    {acceptModal?
                    <div style={{ width: 350 , margin: '0 auto 30px auto' }}>
                        <div className="d-flex" style={{flexDirection: 'column'}}>
                            <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
                                <div className="text-left">
                                    <h5 style={{ marginBottom: 1 }}>Pedido Nº {orderTaken.number}</h5>
                                    <p style={{ marginBottom: 1 }}><i className="bi bi-calendar-date text-primary" style={{ marginRight: 4 }}></i> {extractDate(orderTaken.orderDate)} | <i className="bi bi-clock  text-primary" style={{ marginRight: 4 }}></i> {extractTime(orderTaken.createDate)}</p>
                                    <h5 style={{ marginBottom: 1 }}>{orderTaken.customer.name}</h5>
                                    <p style={{ marginBottom: 1 }}><i className="bi bi-person-badge text-primary" style={{ marginRight: 3 }}></i> {formatCPF(orderTaken.customer.taxId)} | <i className="bi bi-telephone-fill  text-primary"></i> {formatPhoneNumber(orderTaken.customer.phone)}</p>
                                </div>
                            </div>
                            <div className="d-flex flex-col">
                            <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
                            <i className="fa-solid fa-location-dot text-primary" style={{ marginRight: 7 }}></i>
                                {
                                    orderTaken.address.street +
                                    ' ( ' + orderTaken.address.zipCode + ' ) ' +
                                    ', Nº ' +
                                    '' +
                                    ' , ' +
                                    orderTaken.address.city +
                                    ' - ' + orderTaken.address.state
                                }
                            </div>
                            </div>
                        </div>
                    </div>:null}
                    <div className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => handlerOrder(orderTaken.id , 'accept')} className='btn btn-primary'>
                            aceitar pedido
                        </button>
                        {/* <button onClick={() => setAcceptModal(false)} className='btn btn-light'>
                            cancelar
                        </button> */}
                    </div>
                </div>
            </Modal>
            <Modal show={refuseModal} onHide={setRefuseModal} centered>
                <button onClick={() => setRefuseModal(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <i className="fa-regular fa-circle-xmark" style={{ fontSize: 30 }}></i>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}>Recusar Pedido?</h4>
                    <br />
                    {refuseModal?
                        <div style={{ width: 350 , margin: '0 auto 30px auto' }}>
                            <div className="d-flex" style={{flexDirection: 'column'}}>
                                <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
                                    <div className="text-left">
                                        <h5 style={{ marginBottom: 1 }}>Pedido Nº {orderTaken.number}</h5>
                                        <p style={{ marginBottom: 1 }}><i className="bi bi-calendar-date text-primary" style={{ marginRight: 4 }}></i> {extractDate(orderTaken.orderDate)} | <i className="bi bi-clock  text-primary" style={{ marginRight: 4 }}></i> {extractTime(orderTaken.createDate)}</p>
                                        <h5 style={{ marginBottom: 1 }}>{orderTaken.customer.name}</h5>
                                        <p style={{ marginBottom: 1 }}><i className="bi bi-person-badge text-primary" style={{ marginRight: 3 }}></i> {formatCPF(orderTaken.customer.taxId)} | <i className="bi bi-telephone-fill  text-primary"></i> {formatPhoneNumber(orderTaken.customer.phone)}</p>
                                    </div>
                                </div>
                                <div className="d-flex flex-col">
                                <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
                                <i className="fa-solid fa-location-dot text-primary" style={{ marginRight: 7 }}></i>
                                    {
                                        orderTaken.address.street +
                                        ' ( ' + orderTaken.address.zipCode + ' ) ' +
                                        ', Nº ' +
                                        '' +
                                        ' , ' +
                                        orderTaken.address.city +
                                        ' - ' + orderTaken.address.state
                                    }
                                </div>
                                </div>
                            </div>
                        </div>
                    :null}
                    <div className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => handlerOrder(orderTaken.id , 'refuse')} className='btn btn-primary'>
                            recusar pedido
                        </button>
                        <button onClick={() => setRefuseModal(false)} className='btn btn-light'>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <span style={{zIndex: 9999 , width: '100%' , height: '100vh' , backgroundColor: 'rgba(41 ,180,226,0.6)' , position: 'absolute' , top: 0, right: 0, display: loading?'flex':'none' , justifyContent: 'center' , alignItems: 'center'}} >
                <i id="loading-arrow-in-circle" className="bi bi-arrow-clockwise" style={{color: 'white' , fontSize: 75}}></i>
            </span>
        </>
    )
}
export default FoodOrder;
